module.exports = {
  GA_MEASUREMENT_ID: process.env.REACT_APP_GA_MEASUREMENT_ID,
};
